import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FlexDiagnosticWindow } from 'app/shared/models/flex-diagnostic-window';

const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;

@Component({
    selector: 'app-diagnostic-window-card',
    templateUrl: './diagnostic-window-card.component.html',
    styleUrls: ['./diagnostic-window-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticWindowCardComponent {
    @Input() public locationName: string;
    @Input() public window: FlexDiagnosticWindow;
    @Input() public nextExpectedDiagnosticSession: Date | null;
    @Input() public customerDateFormat: string;

    @Output() public edit = new EventEmitter<void>();
    @Output() public deleteWindow = new EventEmitter<void>();

    public get frequencyHours(): number {
        return this.window ? this.window.interval / SECONDS_PER_HOUR : 0;
    }

    public get windowDurationMinutes(): number {
        return this.window ? this.window.extendSession / SECONDS_PER_MINUTE : 0;
    }
}
